import script from "./DevelopmentScope.vue?vue&type=script&setup=true&lang=js"
export * from "./DevelopmentScope.vue?vue&type=script&setup=true&lang=js"

import "./DevelopmentScope.vue?vue&type=style&index=0&id=05168900&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05168900"]])

export default __exports__